/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { useSpring, animated } from 'react-spring';
import s from './Callout.css';

function Callout({ children, size, type }) {
  const props = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <animated.div style={props}>
      <div key="callout" className={`${s[size]} ${s[type]}`}>
        <div className={s.message}>
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
          {children}
        </div>
      </div>
    </animated.div>
  );
}

Callout.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', '']),
  type: PropTypes.oneOf(['alert', 'success', 'warning', '']),
};

Callout.defaultProps = {
  size: '',
  type: '',
};

export default withStyles(s)(Callout);



// WEBPACK FOOTER //
// ./src/components/Callout/Callout.js